'use es6';

import Client from 'ads-account-connection/data/Client';
const AD_ACCOUNTS_BASE = `ads/v1/ad-account`;
export default {
  createAdwordsAdAccount(data) {
    return Client.apiRequest(`${AD_ACCOUNTS_BASE}/create/adwords`, {
      type: 'POST',
      data
    });
  },

  validateAdwordsSetup(adAccountId, networkUserId) {
    return Client.apiRequest(`${AD_ACCOUNTS_BASE}/adwords/${adAccountId}/${networkUserId}/validate-setup`);
  }

};